<template>
  <div>
    <div class="login_logo" @click="$projCommon.navTo({'path': '/'}, {})">
      <img src="@/assets/images/login_logo@2x.png" width="296" height="55" />
    </div>
    <Landing>
      <FindPwd :type="'phone'" @next="next" @ready-to-get-code="getAuthCode" @to-last-step="toLastStep"></FindPwd><!-- type: phone|email|all -->
    </Landing>
  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import Landing from '@/pages/others/landing.vue'
  import FindPwd from '@/components/common/find-pwd/index.vue'
  import { mapActions } from 'vuex'
  export default {
    components: { Landing, FindPwd },
    mounted () {
    },
    data () {
      return {
      }
    },
    computed: {
    },
    methods: {
      ...mapActions('pwdreset', {
        getCode: 'getCode'
      }),
      getAuthCode (phone) {
        if (phone && phone !== (null || undefined || '')) {
          this.getCode(phone)
        }
      },
      toLastStep () {
        window.history.go(-1)
      },
      next (f) {
        this.validatePhone(f)
      },
      validatePhone (f) { // 验证手机号是否注册,并重置密码
        api.post(config.bylBaseCenterPath, '/findPassword/validate-phone', {
          phone: f.phone,
          code: f.code,
          password: f.password
        }, (r) => {
          this.$toasted.show('重置密码成功')
          this.$router.push({path: '/login'})
        })
      }
    }
  }
</script>
<style scoped>
  @import 'assets/login.css';
</style>



// WEBPACK FOOTER //
// src/pages/auth/pagePwdForget.vue